<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1); 
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;}
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

  @keyframes bike-left {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #bike-left {
    animation-name: bike-left;
  }
  @keyframes bike-right {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #bike-right {
    animation-name: bike-right;
  }
  
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 242.9 101.2" height="100%" width="100%">
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="bike-left">
      <path
        fill="var(--shirt)"
        d="M70 48c1 1 0 3-1 5-1 1-1 3 1 4a4 4 0 0 1 1 1l13 4c1 0 10 2 11 1l3-1 1 3a37 37 0 0 0 0 14c0 3 1 7 3 9a8 8 0 0 1 3 5 2 2 0 0 0 2 2 11 11 0 0 1 5 2l-2 1c-3 2-6 3-10 1a132 132 0 0 0-19 0l-29 2h-7c-4-1-5-5-7-4a5 5 0 0 1-1 0c-3 0-4 0-5-2a22 22 0 0 1 3 0l1-2a3 3 0 0 1 2-3c4-2 4-6 1-8-3-3-6-6-10-7l-2-1a2 2 0 0 1 2 0 2 2 0 0 0 3-1 16 16 0 0 1 1-1 3 3 0 0 0 4-1 6 6 0 0 1 3-1 57 57 0 0 0 10-2 3 3 0 0 0 2-3 12 12 0 0 0-1-5 26 26 0 0 1-2-8 4 4 0 0 1 2-3 5 5 0 0 0 3-4 7 7 0 0 1 3-4l1 3 3 4a8 8 0 0 0 7 0 6 6 0 0 1 2 0Z"
      />
      <path
        fill="var(--flesh)"
        d="M70 48a6 6 0 0 0-2 0 8 8 0 0 1-7 0l-3-4-1-3a1 1 0 0 0 1-1l2-5-5 2a30 30 0 0 0-10 6v2c1 1 2 2 1 4a1 1 0 0 0 0 1 22 22 0 0 1 3 3 26 26 0 0 0 2 7 12 12 0 0 1 1 5 3 3 0 0 1-2 3 57 57 0 0 1-10 2 6 6 0 0 0-3 1 3 3 0 0 1-4 1l-2-4-2-1a16 16 0 0 0-3-1 11 11 0 0 1-5 0c-2-1-5 1-5 4a18 18 0 0 1 1 3l1 1h9l2 1c4 1 7 4 10 7 3 2 3 6-1 8a3 3 0 0 0-2 3l-1 2a22 22 0 0 0-3 0l-5-1c-8-1-15-4-23-7l-2-1a22 22 0 0 0-2-4v-4l3-6a62 62 0 0 1 6-10 1 1 0 0 0 1-1 6 6 0 0 1 0-4 4 4 0 0 0 0-4 24 24 0 0 1-1-5v-1l2 1c1 1 0 2 2 3a31 31 0 0 1 1 4v1l3 1 2 3c1 1 3 2 4 1h5v-2c-2-1-4-3-3-6a8 8 0 0 0-1-3 2 2 0 0 1 2-3 45 45 0 0 1 5-2 10 10 0 0 0 8-6 4 4 0 0 0 0-4 31 31 0 0 0 10-5 53 53 0 0 1 18-10l4-1a3 3 0 0 1 3 0 17 17 0 0 1 3 4 6 6 0 0 1 0 6 77 77 0 0 0-3 9 42 42 0 0 1-4 10ZM96 51l-1-6-4-18a19 19 0 0 1 2-12c1-2 4-3 6-3h3a12 12 0 0 1 9 3l11 6 18 9a20 20 0 0 0 9 2 6 6 0 0 0 2 2 1 1 0 0 1 1 0 13 13 0 0 1 1 5 3 3 0 0 1-2 3 9 9 0 0 1-4 0 6 6 0 0 0-2 0h-2l-13-3a10 10 0 0 0-4 0 15 15 0 0 1-9 0l-2-1 1 1 9 12v1l2 6c1 1 1 1-1 1l-9 1c-6 1-6 1-8-4a3 3 0 0 0-3-2 13 13 0 0 1-4 0l-6-3Z"
      />
      <path
        fill="var(--pants)"
        d="m96 51 6 3a13 13 0 0 0 4 0 3 3 0 0 1 3 2c2 5 2 4 8 4l9-1c2 0 2 0 1-1l-2-6 2 1 2 1c3-2 6-2 9-2v3a40 40 0 0 0-1 5c0 1 1 2 2 1l1 1a8 8 0 0 1-1 3c-2 4-1 7 2 9 1 1 2 2 3 1a6 6 0 0 1 3-1 5 5 0 0 1-1 2 3 3 0 0 1-3 2c-3 0-4 1-6 3a2 2 0 0 1-2 1 3 3 0 0 0-4 2l-2 5c-2 4-5 6-9 7a70 70 0 0 1-8 1 11 11 0 0 0-5-2 2 2 0 0 1-2-2 8 8 0 0 0-3-5c-2-2-3-6-3-9a37 37 0 0 1 0-14l-1-3-1-3a1 1 0 0 1 0-1 14 14 0 0 0-1-7Z"
      />
      <path
        fill="var(--flesh)"
        d="M147 74a6 6 0 0 0-3 1c-1 1-2 0-3-1-3-2-4-5-2-9a8 8 0 0 0 1-3l-1-1c-1 1-2 0-2-1a40 40 0 0 1 1-5v-3a3 3 0 0 1 1 0 54 54 0 0 1 8-1l3-1c2 0 2 1 3 2a2 2 0 0 0 3 1 11 11 0 0 0 3-4l4-5h1l4-1a12 12 0 0 1 4-1c3 0 5-1 8-3a148 148 0 0 1 15-6c6-3 11-5 16-10l1-1h2c2 1 3 5 3 7a11 11 0 0 1-3 5l-1 1-4 2-14 10a16 16 0 0 1-3 3l-11 5-8 2c-4 1-8 4-11 6l-15 11Z"
      />
      <path
        fill="var(--hair)"
        d="m163 44-4 5a11 11 0 0 1-3 4 2 2 0 0 1-3-1c-1-1-1-2-3-2a10 10 0 0 1-3-4 5 5 0 0 0-2-3v-1a6 6 0 0 1 2 0 9 9 0 0 0 4 0 3 3 0 0 0 2-3 13 13 0 0 0-1-5 1 1 0 0 0-1 0 6 6 0 0 1-2-2l2-1a30 30 0 0 0 5-1 19 19 0 0 0 10-5 39 39 0 0 1 3-3c2-1 4-1 5 2 1 4 0 7-2 10a27 27 0 0 1-9 10ZM213 35l1-1a11 11 0 0 0 3-5c0-2-1-6-3-7h-2c-1 0-2 0-1-1 4-3 6-7 8-12a15 15 0 0 0 2-3 20 20 0 0 1 1-3c0-1 1-3 3-3s3 2 3 3a15 15 0 0 1 1 11 46 46 0 0 0-1 16 8 8 0 0 1 0 5l-2 1-9-2a1 1 0 0 0-2 1 2 2 0 0 1-2 0ZM39 35a4 4 0 0 1 0 4 10 10 0 0 1-8 6 45 45 0 0 0-5 2 2 2 0 0 0-2 3 8 8 0 0 1 1 3c-1 3 1 5 3 6v2h-5c-1 1-3 0-3-1l-3-3-3-1v-1a31 31 0 0 0-1-4l-1-2 1-3a3 3 0 0 0 2-3 4 4 0 0 1 1-2c4-4 8-6 13-6l5-1h4a7 7 0 0 1 1 1Z"
      />
      <path fill="var(--pants)" d="M125 51v1-1Z" />
    </g>
    <g id="bike-right">
      <path
        fill="var(--hair)"
        d="M158 0a7 7 0 0 1 3 5c2 6 2 11-2 17l-2 7-2 8a11 11 0 0 1 0 2c-1 3-2 3-5 2a3 3 0 0 0-1-1 11 11 0 0 1-8-2 3 3 0 0 0-2-1l-1-1a6 6 0 0 1 2-1 5 5 0 0 0 2-7 4 4 0 0 1 0-3l-1-1a5 5 0 0 1-3-1 2 2 0 0 1 0-1h1a2 2 0 0 0 1-1h1v-1h1a11 11 0 0 0 3-2v-1l1-1a26 26 0 0 0 7-11 8 8 0 0 1 3-5ZM223 34a5 5 0 0 1 1-4c4-4 6-9 7-14l2-6c1-3 3-4 6-1 2 2 3 5 3 8l1 2v6a23 23 0 0 0-2 8v10c0 3-1 4-4 4l-10-1a7 7 0 0 1-1-1l3-2c2-1 3-2 1-5a10 10 0 0 0-7-4Z"
      />
      <path
        fill="var(--shirt)"
        d="M22 74a16 16 0 0 1-1-4c1-3 2-4 4-3h1l2 1 2 3c1 1 1 2 3 1a43 43 0 0 1 4-3 23 23 0 0 0 6-5 3 3 0 0 0 1-1 16 16 0 0 1 3-8l1-1c1-1 1-3 3-3h1l3-6 2 1 3 3a30 30 0 0 0 5 6 3 3 0 0 0 3 1v3a7 7 0 0 0-1 1 1 1 0 0 0 0 2l3 1a2 2 0 0 1 3 1l8 1a74 74 0 0 0 8 0l1 2 5 4c4 3 8 6 9 11a97 97 0 0 1 3 16l-9 3a4 4 0 0 1-3 0 7 7 0 0 0-5-1 55 55 0 0 1-16 1l-24-5-9-4a53 53 0 0 1-8-3 8 8 0 0 1-3-3 3 3 0 0 1-1-2c1-2 0-3-1-3a7 7 0 0 1-4-4l-2-3Z"
      />
      <path
        fill="var(--pants)"
        d="M107 98a97 97 0 0 0-3-16c-1-5-5-8-9-11l-5-4-1-2a1 1 0 0 0 0-1c-2-1-1-2-1-3 2-2 2-2-1-4l-1-1a2 2 0 0 1-1-3 8 8 0 0 0-1-4l-2-5v-4a16 16 0 0 0 7 4c6 2 13 1 19 0 2 0 2 1 3 2a24 24 0 0 0 3 5l2 2c3 1 4 4 4 6s1 3 4 3l9-1a10 10 0 0 1 5 0l4 6a108 108 0 0 1 2 13c1 2 1 4-1 5-5 3-11 5-16 9a51 51 0 0 0-5 5 3 3 0 0 1-2 1l-12-1-1-1Z"
      />
      <path
        fill="var(--flesh)"
        d="M68 56a3 3 0 0 1-2-1 30 30 0 0 1-6-6l-3-3-2-1 3-6-6 2-9 4c-1 0-2 0-1 1a3 3 0 0 1 1 3v1c3 1 3 3 4 5a16 16 0 0 0-3 8 3 3 0 0 1-1 1 23 23 0 0 1-6 5 43 43 0 0 0-4 3c-2 1-2 0-3-1l-2-3-2-1h-1c-2-1-3 0-4 3a16 16 0 0 0 1 4l-7-2a4 4 0 0 1-3-5 54 54 0 0 1 1-7 20 20 0 0 0-1-4l1-6h1a13 13 0 0 1 7-3v-1a2 2 0 0 0-1 0 16 16 0 0 0-3 1l-2-1 1-1a12 12 0 0 1 2-1 62 62 0 0 0 8-2 19 19 0 0 1 6-2 4 4 0 0 0 3-1l5-3a71 71 0 0 0 9-5 7 7 0 0 0 1 0c6-4 12-6 19-9a4 4 0 0 1 4 1c2 2 4 5 3 8l-2 12c-1 5-4 9-6 13Zm-36 7c-2-1-1-2-1-4a12 12 0 0 1 1-3c1 0 2-1 1-2h-2a6 6 0 0 0-3 2l-3 2a4 4 0 0 0-2 5l4 4a1 1 0 0 0 1-1 35 35 0 0 0 4-3Zm7-16c-1 4 0 5 3 6Zm-6 15c3-1 3-2 2-4l-2 4ZM21 50a11 11 0 0 0-4 2v1h1l3-3Zm1 6-2 1v1a1 1 0 0 0 1 0l1-2ZM143 85c2-1 2-3 1-5a108 108 0 0 0-2-13c-1-2-2-5-4-6a1 1 0 0 1 0-1l15-4a45 45 0 0 1 7 0 3 3 0 0 0 2-1 9 9 0 0 1 5-1l10-1c4 0 7-2 11-3l17-6a47 47 0 0 0 18-10 10 10 0 0 1 7 4c2 3 1 4-1 5l-3 2-14 7-8 5c-4 3-8 6-13 7a39 39 0 0 1-10 2c-6-1-11 2-16 5l-21 14h-1ZM108 44c-6 1-13 2-19 0a16 16 0 0 1-7-4l-2-6c-2-5-3-11-1-17v-1a14 14 0 0 1 2-1c5-2 10-3 15 0a7 7 0 0 0 2 0v1h1l4 1c5 0 9 2 14 3a12 12 0 0 0 3 1h1a2 2 0 0 0 1 0c5 2 11 3 16 2a5 5 0 0 0 3 1l1 1a4 4 0 0 0 0 3 5 5 0 0 1-2 7 6 6 0 0 0-2 1 57 57 0 0 0-11-2h-9a33 33 0 0 0-4 1H99a4 4 0 0 0 2 2 86 86 0 0 1 6 6l1 1Z"
      />
      <path
        fill="var(--hair)"
        d="M35 39a4 4 0 0 1-3 1 19 19 0 0 0-6 2 62 62 0 0 1-8 2 12 12 0 0 0-2 1l-1 1 2 1a16 16 0 0 1 3-1 2 2 0 0 1 2 0l-1 1a13 13 0 0 0-7 3h-1a9 9 0 0 1 4-8c3-2 6-5 10-5a11 11 0 0 1 7 0Z"
      />
      <path fill="var(--flesh)" d="M22 74Z" />
      <path
        fill="var(--hair)"
        d="M32 63a35 35 0 0 1-4 3 1 1 0 0 1-1 1l-4-4a4 4 0 0 1 2-5l3-2a6 6 0 0 1 3-2h2l-1 2a12 12 0 0 0-1 3c0 2-1 3 1 4ZM39 47l3 6c-3-1-4-2-3-6ZM33 62l2-4c1 2 0 3-2 4Z"
      />
      <path
        fill="var(--pants)"
        d="m21 50-3 3h-1v-1a11 11 0 0 1 4-2ZM22 56l-1 2a1 1 0 0 1-1 0v-1l2-1Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>